import React from 'react'

import { Divider, DividerProps } from './Divider'

export const HorizontalRule: React.FC<DividerProps> = (props) => (
  <Divider {...props} />
)

HorizontalRule.displayName = 'Content.HorizontalRule'
